import { PromoEventValues } from '~features/promoEvent/config';

export const enum PaymentReason {
	RetentionPopupCTA = 'RETENTION_POPUP_CTA',
	PromoEvent = PromoEventValues.CheckoutReason,
	Deeplink = 'deeplink',
	ImageGeneration = 'image_generation',
	ImageGenerationWaiting = 'image_generation_waiting',
	ImageUnlimitedHistory = 'image_unlimited_history',
	ImageUpgradeToPremium = 'image_upgrade_to_premium',
	ImageUpgradeToGenerateMore = 'image_upgrade_to_generate_more',
	VideoGeneration = 'video_generation',
	VideoUnlimitedHistory = 'video_unlimited_history',
	TopMenu = 'top_menu',
	TopMenuPromo = 'top_menu_promo',
	LeftMenu = 'left_menu',
	LeftMenuLearnMore = 'left_menu_learn_more',
	NewBotFirstOpen = 'new_bot_first_open',
	OnboardingCompleted = 'onboarding_completed',
	LockedBot = 'locked_bot',
	ChangeModel = 'change_model',
	Gift = 'gift',
	Sexting = 'sexting',
	MsgRegeneration = 'msg_regeneration',
	AudioListening = 'audio_listening',
	AiPhoto = 'ai_photo',
	AiVideo = 'ai_video',
	AiMediaPack = 'ai_media_pack',
	VideoFromImageGeneration = 'video_from_image_generation',
	Unknown = 'unknown',
}

export const enum PaymentReasonType {
	Grid = 'grid',
	Gallery = 'gallery',
	SingleMediaPage = 'single_media_page',
	RelatedMedia = 'related_media',
	CreatorProfile = 'creator_profile',
	Chats = 'chats',
	Chat = 'chat',
	BotProfile = 'bot_profile',
	GToolMedia = 'gtool_media',
	GToolBot = 'gtool_bot',
	Onboarding = 'onboarding',
	Unknown = 'unknown',
}
